<template>
  <div :class="isPC ? 'tab-bar-item' : 'm-tab-bar-item'" @click="itemClick">
    <!-- 展示底层文字的插槽 -->
    <div :style="activeStyle" v-show="!isActive">
      <slot name="item-text"></slot>
    </div>
    <div :style="activeStyle" v-show="isActive">
      <slot name="item-text-active"></slot>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'TabBarItem',
    props: {
      path: String,
      activeColor: {
        type: String,
        default: 'white'
      },
    },
    data() {
      return {
      }
    },
    computed: {
      isActive() {
        return this.$route.path.indexOf(this.path) !== -1
      },
      activeStyle() {
        return this.isActive ? { color: this.activeColor } : {}
      }
    },
    methods: {
      itemClick() {
        this.$router.replace(this.path).catch(err => err)
      }
    }
  }
</script>
<style scoped>
  .tab-bar-item {
    width: 100px;
    height: 75px;
    font-family: MiSans, MiSans;
    font-weight: 400;
    font-size: 16px;
    color: #111111;
    line-height: 75px;
    text-align: center;
    font-style: normal;
    transform: translate(0px, -2px);
  }
</style>



// WEBPACK FOOTER //
// src/components/NavigatBar/NavigatBarItem.vue